import * as React from 'react'

export type GlobalSearchContextValue = {
  isOpen: boolean
  open: () => void
  close: () => void
}

const DEFAULT_CONTEXT: GlobalSearchContextValue = {
  isOpen: false,
  open: () => undefined,
  close: () => undefined,
}

export const GlobalSearchContext =
  React.createContext<GlobalSearchContextValue>(DEFAULT_CONTEXT)

export const GlobalSearchProvider = ({
  children,
}: React.PropsWithChildren<{}>) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const open = React.useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = React.useCallback(() => {
    setIsOpen(false)
  }, [])

  const value = React.useMemo<GlobalSearchContextValue>(
    () => ({ isOpen, open, close }),
    [isOpen, open, close]
  )

  return (
    <GlobalSearchContext.Provider value={value}>
      {children}
    </GlobalSearchContext.Provider>
  )
}

export const useGlobalSearch = (): GlobalSearchContextValue => {
  return React.useContext(GlobalSearchContext)
}
